import React from 'react';
import classNames from 'classnames';
import { Link } from 'react-router';
import Logo from '../logo/Logo';
// import './login.scss';
import "./LoginModal.scss"

const LoginModal = ({
    children,
    className = '',
    tabs = [],
    closeUrl = '/',
    layerUrl = '/',
    back = '',
    rel = '',
    onClose,
}) => {
    const defaultTabs = [
        {
            label: 'SIGN UP',
            url: `/sign-up/${encodeURIComponent(back)}${rel?"/"+rel:""}`,
        },
        {
            label: 'SIGN IN',
            url: `/sign-in/${encodeURIComponent(back)}${rel?"/"+rel:""}`,
        }
    ];

    const tabsToRender = tabs.length > 0 ? tabs : defaultTabs;

    return (
        <section className={`ModalMaster ${className}`}>
            <section className={classNames('Modal active')}>
                <Link
                    to={layerUrl}
                    href={layerUrl}
                    className="Modal__layer"
                    role="button"
                    aria-hidden
                />
                <section className="LoginModal__wrapper">

                    <div className="Modal__header">
                        <Logo />
                        <Link
                            className="Modal__close-btn"
                            to={closeUrl}
                            href={closeUrl}
                            role="button"
                            aria-hidden
                            onClick={(e) => {
                                if (onClose) {
                                    e.preventDefault();
                                    onClose();
                                }
                            }}
                        >
                        </Link>
                    </div>
                    <ul className="Modal__tabs">
                        {tabsToRender.map((tab, index) => (
                            <li key={index}>
                                <Link
                                    className='Modal__tab'
                                    to={tab.url}
                                    href={tab.url}
                                    role="button"
                                    activeClassName="active"
                                    aria-hidden
                                >
                                    {tab.label}
                                </Link>
                            </li>
                        ))}
                    </ul>

                    <div className="Modal__content">

                        {children}

                    </div>
                    <div className="blurb">
                        Designed by game developers and gamers, for game developers and gamers
                    </div>
                </section>
            </section>
        </section>
    );
};

export default LoginModal;
